import { render } from "./UserPredictionsTable.vue?vue&type=template&id=382e04cd&scoped=true"
import script from "./UserPredictionsTable.vue?vue&type=script&lang=js"
export * from "./UserPredictionsTable.vue?vue&type=script&lang=js"

import "./UserPredictionsTable.vue?vue&type=style&index=0&id=382e04cd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382e04cd"]])

export default __exports__